/**
 * SosPasteDefaultsSection ("Add SOS") — Settings control for what Add SOS ticks by default.
 *
 * Personal to this user (kept in this browser, see utils/sosPasteDefaults.ts), like OT colours.
 */
import { setUntickShiftStartSos, useUntickShiftStartSos } from "@/utils/sosPasteDefaults";

export function SosPasteDefaultsSection() {
  const untick = useUntickShiftStartSos();
  return (
    <label style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 14, cursor: "pointer" }}>
      <input
        type="checkbox"
        checked={untick}
        onChange={(e) => setUntickShiftStartSos(e.target.checked)}
        style={{ width: 16, height: 16, marginTop: 2, cursor: "pointer" }}
      />
      <span>
        Untick SOS officers who start at the start of the shift
        <span style={{ display: "block", fontSize: 13, color: "#64748b", marginTop: 2 }}>
          When you paste a list in Add SOS. They are normally seated when the roster is generated, so adding
          them again would double them up. Only for you — it is saved in this browser.
        </span>
      </span>
    </label>
  );
}
